import Home from '@/views/Home'
import Consulting from '@/views/Consulting'
import Interior from '@/views/Interior'
import Outside from '@/views/Outside'
import Special from '@/views/Special'
import Partner from '@/views/Partner'
import Impress from '@/views/Impress'
import Safety from '@/views/Safety'
import About from '@/views/About'

export default [
    {
        name: 'home',
        link: '/home',
        component: Home,

        icon: 'home.svg',
        title: 'Wer wir sind',
        description: ''
    },
    {
        name: 'about-us',
        link: '/about-us',
        component: About,

        icon: 'team.svg',
        title: 'Unsere Geschichte',
        description: ''
    },
    {
        name: 'consulting',
        link: '/consulting',
        component: Consulting,

        icon: 'sketch.svg',
        title: 'Planen & Beraten',
        description: ''
    },
    {
        name: 'interior',
        link: '/interior',
        component: Interior,

        icon: 'interior.svg',
        title: 'Innenausbau',
        description: ''
    },
    {
        name: 'outside',
        link: '/outside',
        component: Outside,

        icon: 'outdoor.svg',
        title: 'Außenbereich\nGarten',
        description: ''
    },
    {
        name: 'safety',
        link: '/safety',
        component: Safety,

        icon: 'window.svg',
        title: 'Türen & Fenster\nSicherheit',
        description: ''
    },
    {
        name: 'special',
        link: '/special',
        component: Special,

        icon: 'idea.svg',
        title: 'Besonderes',
        description: ''
    },
    // {
    //     name: 'samples',
    //     link: '/samples',

    //     icon: 'tags.svg',
    //     title: 'Holzmuster',
    //     description: ''
    // },
    {
        name: 'partners',
        link: '/partners',
        component: Partner,

        icon: 'partners.svg',
        title: 'Partner',
        description: ''
    },
    {
        name: 'impress',
        link: '/impress',
        component: Impress,

        icon: 'balance.svg',
        title: 'Impressum\nDatenschutz',
        description: ''
    }
  ]